module.exports = {"130682001":"南城区街道","130682002":"北城区街道","130682003":"西城区街道","130682004":"长安路街道","130682100":"留早镇","130682101":"清风店镇","130682102":"庞村镇","130682103":"砖路镇","130682104":"明月店镇","130682105":"叮咛店镇","130682106":"东亭镇","130682107":"大辛庄镇","130682108":"东旺镇","130682109":"高蓬镇","130682110":"邢邑镇","130682111":"李亲顾镇","130682112":"子位镇","130682113":"开元镇","130682115":"周村镇","130682116":"息冢镇","130682203":"东留春乡","130682204":"号头庄回族乡","130682205":"杨家庄乡","130682206":"大鹿庄乡","130682208":"西城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130682.json
// module id = 175
// module chunks = 0